import 'jquery-validation';
import {showButtonLoader, hideButtonLoader} from '../util/helpers';

export default {
  init: function () {
    var inviteFriendForm = $('#inviteFriendForm');
    var submitButton = $('#wp-submit');

    submitButton.on('click', function (e) {
      e.preventDefault();
      showButtonLoader(submitButton);

      setTimeout(() => {
        var valid = inviteFriendForm.valid();
        if (valid) {
          setTimeout(function () {
            inviteFriendForm.submit();
          }, 1000);
        }else {
          hideButtonLoader(submitButton);
        }
      }, 1000);
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/inviteFriend.js